import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Client from "../../../common/axiosApi";
import Loader from "../../../common/loader/Loader";
import { toast } from "react-toastify";

const Form = () => {
  const [loader, setLoader] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    setLoader(true);
    try {
      const submitEnquiry = await Client.post("/enquiry/enquiryPost", data);
      console.log(submitEnquiry);
      if (submitEnquiry.status === 200) {
        setLoader(false);
        // alert("form submitted");
        toast.success('Form Submitted Successfully')
        reset();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {loader && <Loader />}
      <div className="about-us-back">
        <div className="container con e-con-inner about-us-top">
          <div className="about-us-flex ">
            <div
              style={{
                textAlign: "-webkit-center",
              }}
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="row"
                  style={{
                    padding: "0px 10px",
                  }}
                >
                  <div className="form-group col-md-12 mb-3 mt-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      name="name"
                      {...register("name", {
                        required: "Name is required",
                        pattern: {
                          value: /^[A-Za-z" "]+$/,
                          message: "Alphabets only allowed",
                        },
                      })}
                    />
                    {errors.name && (
                      <p style={{ color: "red", display: "inline" }}>
                        {errors.name.message}
                      </p>
                    )}
                  </div>

                  <div className="form-group col-md-12 mb-3 mt-2">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value:
                            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                          message: "Email is invalid",
                        },
                      })}
                    />
                    {errors.email && (
                      <p style={{ color: "red" }}>{errors.email.message}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Subject"
                      name="subject"
                      {...register("subject", {
                        required: "Subject is required",
                        pattern: {
                          value: /^[^\s]/,
                          message: "Subject should not start with a space",
                        },
                      })}
                    />
                    {errors.subject && (
                      <p style={{ color: "red" }}>{errors.subject.message}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <textarea
                      className="form-control"
                      placeholder="Please Describe what you need"
                      rows="5"
                      name="query"
                      {...register("query", {
                        required: "Description is required",
                        pattern: {
                          value: /^[^\s]/,
                          message: "Description should not start with a space",
                        },
                      })}
                    />
                    {errors.query && (
                      <p style={{ color: "red" }}>{errors.query.message}</p>
                    )}
                  </div>
                </div>
                <button type="submit">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
